import {ColorRestDto, TextColorGradientRestDto, TextColorValueRestDto} from "@/api/pharma-cms-content-page/models";
import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {TextColorGradientRestDtoModel} from "@/models/api/TextColorGradientRestDtoModel";
import {TextColorEnum} from "@/api/enums/text-color-enum";

export class TextColorValueRestDtoModel implements TextColorValueRestDto {
    text_color_code?: TextColorEnum | null;
    rgba?: ColorRestDto | null;
    gradient?: TextColorGradientRestDto | null;

    static createWithDefaults(): TextColorValueRestDtoModel {
        const model: TextColorValueRestDtoModel = new this();

        model.text_color_code = null;
        model.rgba = null;
        model.gradient = null;

        return model;
    }

    static cloneFrom(source: TextColorValueRestDto): TextColorValueRestDtoModel {
        const clone: TextColorValueRestDtoModel = new this();

        clone.text_color_code = source.text_color_code;
        if (source.rgba) {
            clone.rgba = ColorRestDtoModel.cloneFrom(source.rgba);
        }
        if (source.gradient) {
            clone.gradient = TextColorGradientRestDtoModel.cloneFrom(source.gradient);
        }

        return clone;
    }
}
